import apiClient from './apiClient';

class OTPService {
  async execute(method, resource, data) {
    return apiClient({
      method,
      url: resource,
      data,
    });
  }

  // Send OTP to phone number
  async sendOTP(phone) {
    try {
      const response = await this.execute("post", "/send-otp/", { phone });
      return response.data;
    } catch (error) {
      console.error('Error sending OTP:', error);
      throw error;
    }
  }

  // Verify OTP and login
  async verifyOTP(phone, otpCode) {
    try {
      const response = await this.execute("post", "/verify-otp/", { 
        phone, 
        otp_code: otpCode 
      });
      return response.data;
    } catch (error) {
      console.error('Error verifying OTP:', error);
      throw error;
    }
  }

  // Validate phone number format
  validatePhoneNumber(phone) {
    const errors = [];
    
    if (!phone) {
      errors.push("Phone number is required");
    } else if (!/^\d{10}$/.test(phone)) {
      errors.push("Phone number must be exactly 10 digits");
    }
    
    return {
      isValid: errors.length === 0,
      errors: errors
    };
  }

  // Format phone number input (only digits, max 10)
  formatPhoneInput(value) {
    // Only allow digits
    const digitsOnly = value.replace(/\D/g, '');
    
    // Limit to 10 characters
    const limited = digitsOnly.substring(0, 10);
    
    return limited;
  }

  // Validate OTP format
  validateOTP(otp) {
    const errors = [];
    
    if (!otp) {
      errors.push("OTP code is required");
    } else if (!/^\d{6}$/.test(otp)) {
      errors.push("OTP code must be exactly 6 digits");
    }
    
    return {
      isValid: errors.length === 0,
      errors: errors
    };
  }

  // Format OTP input (only digits, max 6)
  formatOTPInput(value) {
    // Only allow digits
    const digitsOnly = value.replace(/\D/g, '');
    
    // Limit to 6 characters
    const limited = digitsOnly.substring(0, 6);
    
    return limited;
  }
}

export default new OTPService();
